import { render, staticRenderFns } from "./gameGroup.vue?vue&type=template&id=1ea5bd5a&scoped=true&"
import script from "./gameGroup.vue?vue&type=script&lang=js&"
export * from "./gameGroup.vue?vue&type=script&lang=js&"
import style0 from "./gameGroup.vue?vue&type=style&index=0&id=1ea5bd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5bd5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea5bd5a')) {
      api.createRecord('1ea5bd5a', component.options)
    } else {
      api.reload('1ea5bd5a', component.options)
    }
    module.hot.accept("./gameGroup.vue?vue&type=template&id=1ea5bd5a&scoped=true&", function () {
      api.rerender('1ea5bd5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/gameGroup.vue"
export default component.exports